export enum Pais {
    PARAGUAY = 'PARAGUAY',
    BRASIL = 'BRASIL',
    ARGENTINA = 'ARGENTINA',
    CHILE = 'CHILE',
    URUGUAY = 'URUGUAY',
    ESTADOS_UNIDOS = 'ESTADOS_UNIDOS',
  }
